module.exports = __webpack_public_path__ + "img/收银机.df7b4362.png";